import React, { useRef, useEffect } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import useLangTranslation from "../../../customHooks/languageProvider";
import { useDispatch } from "react-redux";
import { setShowInfo, setErrorInfo } from "../../AxiosRtk/successMessage";

const ErrorCommonMsg = ({
    showModal,
    defaultMessage,
    message,
    title = null,
    defaultTitle = null,
}) => {
    const modalRef = useRef();
    const { getLangTranslation } = useLangTranslation();
    const dispatch = useDispatch();


    useEffect(() => {
        if (showModal) {
            const modal = new Modal(modalRef.current, {
                backdrop: "static",
                keyboard: false,
            });
            modal.show();
        }
    }, [showModal]);

    const closeModal = () => {
        dispatch(
            setErrorInfo({
                errorInfo: false,
                defaultMessage: "",
                message: "",
                title: "",
                defaultTitle: "",
            })
        );
    };
    return (
        <div className="modal fade" tabIndex="-1" ref={modalRef}>
            <div className="modal-dialog modal-dialog-centered modal-sm">
                <div className="modal-content">
                    <div className="modal-body text-center">
                        <i className='icon-cancel-circle text-danger display-3 d-inline-block rounded-circle mb-6' />
                        {/* <i className="fa-light fa-circle-xmark text-danger"></i> */}
                        <h5 className="text-blue-900 fw-bold mb-5">
                            {title &&
                                defaultTitle &&
                                getLangTranslation(title, defaultTitle)}
                        </h5>
                        {/* <p className="mb-2 text-center fw-400 text-dark mb-9">
                            {message &&
                                defaultMessage &&
                                getLangTranslation(message, defaultMessage)}
                        </p> */}
                        <button
                            className="btn btn-primary w-100"
                            type="button"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={closeModal}
                        >
                            <span className="btn-upper-case">
                                {getLangTranslation("DEFAULT_SETTING_GOT_IT", "Got it")}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ErrorCommonMsg;
